import { render, staticRenderFns } from "./Financeiro.vue?vue&type=template&id=3680bbe0&scoped=true&"
import script from "./Financeiro.vue?vue&type=script&lang=js&"
export * from "./Financeiro.vue?vue&type=script&lang=js&"
import style0 from "./Financeiro.vue?vue&type=style&index=0&id=3680bbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680bbe0",
  null
  
)

export default component.exports